import gql from 'graphql-tag'
import apiClient from '../utils/graphql/graphql'
import loginClient from '../utils/graphql/logingraphql'
//获取微信openid
export function getToken(params) {
    return loginClient.query({
        query: gql`query ($code:String!  $area:String! $user_id:Int!  $article_id:Int!){
            login(code:$code  area:$area  user_id:$user_id  article_id:$article_id)

        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}
//获取权限包
export function getSign(params) {
    return loginClient.query({
        query: gql`query ($url:String!){
            getSign(url:$url){
                appId
                nonceStr
                timestamp
                signature
            }

        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}
//首页
export function getIndex() {
    return apiClient.query({
        query: gql`query {
            getTitle
            getClassify{
                id
                name
                img_url
            }
            getArticle(classify_id:0  title: ""){
                id
                title
                img_url
                desc
                order_num
            }
            getBanner{
                id
                img_url
                type
                link_id
                jump_url
              }
              getStudyDetails{
                self_article_num
                all_article_num
                self_course_num
                all_course_num
              }

        }`,
        fetchPolicy:'no-cache'
        
    })
}

//我的干货排序
export function getSort(params) {
    return apiClient.query({
        query: gql`query ($classify_id:Int  $title:String $time_sort:Int  $hot_sort:Int){
            getArticle(classify_id:$classify_id  title:$title  time_sort:$time_sort  hot_sort:$hot_sort){
                id
                title
                img_url
                desc
                order_num
            }

        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}

//干货详情
export function getIndexDetail(params) {
    return apiClient.query({
        query: gql`query($id:Int!){
            getArticleDetail(id:$id){
                id
                title
                price
                order_num
                share_title
                share_desc
                share_img_url
                part_content
                all_content
                courses{
                id
                course_name
                image
                description
                is_tejia
                virtual_study
                url
              }
                invite_status
                invite_number
              }
              getSelectedCoupon(article_id:$id){
                coupon_user_id
                use_type
                discount
                reduce
                coupon_id
                pay_price
              }
        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}

//下单
export function buy(params) {
    return apiClient.query({
        query: gql`mutation($article_id:Int  $price:Float  $pay_price:Float  $coupon_user_id:Int  $coupon_id:Int){
            createOrder(article_id:$article_id  price:$price  pay_price:$pay_price  coupon_user_id:$coupon_user_id  coupon_id:$coupon_id)
        
        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}

//活动下单
export function activeBuy(params) {
    return apiClient.query({
        query: gql`mutation($activity_id:Int  $price:Float  $pay_price:Float  $coupon_user_id:Int  $coupon_id:Int $phone:String){
            createActivityOrder(activity_id:$activity_id  price:$price  pay_price:$pay_price  coupon_user_id:$coupon_user_id  coupon_id:$coupon_id phone:$phone)
        
        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}

//课程
export function getmycourse() {
    return apiClient.query({
        query: gql`query {
            getCourse{
                id
                course_name
                image
                description
                is_tejia
                virtual_study
                url
              }
            
        }`,
        fetchPolicy:'no-cache',
    })
}

//课程
export function getnewcourse(params) {
    return apiClient.query({
        query: gql`query($menu_id:Int  $tMenu_id:Int){
            courseInfo(menu_id:$menu_id tMenu_id:$tMenu_id){
              menu {
                id
                name
              }
              tMenu {
                id
                name
                name1
                study_status
              }
              imgUrlData {
                img_url
                link_id
              }
              courseData {
                id
                course_name
                image
                description
                is_tejia
                virtual_study
                url
              }
              config{
                name
                data
              }
            }
          }`,
        fetchPolicy:'no-cache',
        variables: params
    })
}

//优惠卷
export function getmycoupons() {
    return apiClient.query({
        query: gql`query {
            getCoupon{
                id
                name
                end_date
                type
                quota
                discount
                reduce
                use_type
              }
            
        }`,
        fetchPolicy:'no-cache',
    })
}

//我的
export function getmy() {
    return apiClient.query({
        query: gql`query {
            getStudyDetails{
                self_article_num
                all_article_num
                self_course_num
                all_course_num
              }
            
        }`,
        fetchPolicy:'no-cache',
    })
}

//我的干货
export function ghList() {
    return apiClient.query({
        query: gql`query {
            getMyArticle{
                id
                title
                img_url
                desc
                order_num
                status
              }  
        }`,
        fetchPolicy:'no-cache',
    })
}

//我的课程
export function recordList() {
    return apiClient.query({
        query: gql`query {
            getMyCourse{
                id
                course_name
                image
                description
                is_tejia
                virtual_study
                status
                url
              } 
        }`,
        fetchPolicy:'no-cache',
    })
}

//我的标签
export function mylabel() {
    return apiClient.query({
        query: gql`query {
            getUserFlag{
                job_type
                school_name
                subject
                education
                trade
                work
                wechat
                edu_year
              }
              getUpdateCoupon{
                use_type
                discount
                reduce
              }
              getIndustry{
                name
              }
              getEducational{
                name
              }
        }`,
        fetchPolicy:'no-cache',
    })
}

//学校搜索
export function getSchool(params) {
    return apiClient.query({
        query: gql`query($school_name:String){
            getSchool(school_name:$school_name){
                school_name
            }
        
        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}

//更新标签
export function updatemylabel(params) {
    return apiClient.query({
        query: gql`mutation($job_type:String!  $school_name:String!  $subject:String!  $education:String!  $trade:String!  $work:String!  $wechat:String! $edu_year:String){
            updateUserFlag(job_type:$job_type  school_name:$school_name  subject:$subject  education:$education  trade:$trade  work:$work  wechat:$wechat edu_year:$edu_year)
        
        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}


//我的干货排序
export function getActive(params) {
    return apiClient.query({
        query: gql`query ($activity_id:Int!){
            getActivity(activity_id:$activity_id){
                id
                title
                content
                price
                market_price
                courses{
                    id
                    course_name
                    image
                    description
                    is_tejia
                    virtual_study
                    url
                }
                coupon{
                    coupon_user_id
                    use_type
                    discount
                    reduce
                    coupon_id
                    pay_price
                }
                img_url
                desc
                is_coupon
                phone
            }

        }`,
        fetchPolicy:'no-cache',
        variables: params
        
    })
}

export function getActivityList() {
    return apiClient.query({
        query: gql`query {
            getActivityList{
                id
                title
                desc
                img_url
              }
            
        }`,
        fetchPolicy:'no-cache',
    })
}


// WEBPACK FOOTER //
// ./src/apollo/apollo.js